export default "<div id=\"locations_div\"></div>"